import AnalyticsService from 'services/analytics.service';
import { DocumentClass } from 'enums/DocumentClass';
import { QuickViewContentTypes } from 'types/quick-view';
import events from './events';

const quickViewEvent = (
  documentId: string | number,
  documentTitle: string,
  documentType: string,
  type: QuickViewContentTypes | '',
  clickType: 'open' | 'close',
) => {
  AnalyticsService.track(events.QUICK_VIEW, {
    document_id: documentId,
    document_title: documentTitle,
    document_type: documentType,
    location: type,
    type: clickType,
  });
};

// TODO: remove with quick view tech debt, no longer in use
export const quickViewClickEvent = (
  documentId: string | number,
  documentTitle: string,
  documentType: string,
) => {
  AnalyticsService.track(events.QUICK_VIEW_CLICK, {
    document_id: documentId,
    document_title: documentTitle,
    document_type: documentType,
    type: DocumentClass.DOCUMENT,
  });
};

export default quickViewEvent;
